// API URL
export const BASE_URL = import.meta.env.VITE_API_URL
export const BASE_URL_V2_1 = import.meta.env.VITE_API_URL_V2_1
export const BASE_URL_V3 = import.meta.env.VITE_API_URL_V3
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL

// 外部サービス
export const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY

// 利用規約
export const TERM_OF_USE_1 = import.meta.env.VITE_TERM_OF_USE_1
export const TERM_OF_USE_2 = import.meta.env.VITE_TERM_OF_USE_2

// 機能フラグ
export const SHOW_CSV_UPLOAD = import.meta.env.VITE_SHOW_CSV_UPLOAD === 'true'

// お知らせ
export const NOTICE_REVISION_TXT_URL = `${import.meta.env.VITE_NOTICE_URL}notice-revision.txt`
export const NOTICES_JSON_URL = `${import.meta.env.VITE_NOTICE_URL}notices.json`
